import { useState } from 'react';

import { IName } from '@interfaces/common/common';

export const useNameValidation = (defaultName: string | undefined, checkNameFn: (data: IName) => Promise<boolean>) => {
	const [validationName, setValidationName] = useState<string | undefined>(defaultName);

	const validateName = async (name: string): Promise<boolean> => {
		if (name === defaultName || name === validationName) {
			return true;
		}

		return new Promise((resolve) => {
			checkNameFn({ name })
				.then(() => {
					setValidationName(name);
					resolve(true);
				})
				.catch(() => {
					resolve(false);
				});
		});
	};

	return { validateName };
};
